(function () {
    function endsWith(str, suffix) {
    	return str.indexOf(suffix, str.length - suffix.length) !== -1;
	}
  
    var whitelist = [
    "Atari Lynx",
    "Atari 2600",
    "Atari XE",
    "CDi",
    "Colecovision",
    "Commodore",
    "Commodore 64",
    "FCF",
    "Game Boy Color",
    "Game.com",
    "Gamecube",
    "Intellivision",
    "Magnavox Odyssey",
    "Magnavox Odyssey 2",
    "Microsoft Xbox",
    "Microsoft Xbox 360",
    "Microsoft Xbox One",
    "Neo Geo Pocket",
    "NEOGEO",
    "Nintendo 3DS",
    "Nintendo 64",
    "Nintendo DS",
    "Nintendo Famicom",
    "Nintendo Game Boy",
    "Nintendo Game Boy Advance", 
   "Nintendo Switch",
    "Nintendo NES",
    "Nintendo NES Bundle",
    "Nintendo SNES",
    "Nintendo SNES Bundle",
    "Nintendo Virtual Boy",
    "Nintendo Wii",
    "Nintendo WiiU",
    "Nokia N-Gage",
    "NUON",
    "Sega 32X",
    "Sega CD",
    "Sega Dreamcast",
    "Sega Game Gear",
    "Sega Genesis",
    "Sega Master System",
    "Sega Pico",
    "Sega Saturn",
    "SG32XCD",
    "Sony Playstation 1",
    "Sony Playstation 2",
    "Sony Playstation 3",
    "Sony Playstation 4",
    "Sony PSP",
    "TI99",
    "TurboGrafx-16",
    "TurboGrafx-16 CD",
    "TurboGrafx-16 Super CD",
    "Vectrex",
    "Vita",
    "VITA",
    "Wonder Swan",
     "3DO",  "Atari 5200",  "Atari 7800",  "Atari 400/800",  "Amiga",  "Amiibo",  "Aquarius",  "Arcadia",  "Atari Jaguar",  "MP1000",  "Sony Playstation 5",  "Nintendo Super Famicom",  "SKY",  "TRS80",  "Microsoft Xbox Series X S"
    ];


  
var app = angular.module('tradein', []);

app.config(['$interpolateProvider', function($interpolateProvider) {
  $interpolateProvider.startSymbol('{[{');
  $interpolateProvider.endSymbol('}]}');
}]);
  

app.controller('stepone', ['$scope','$http','$timeout','$location','$filter',
                           function($scope, $http, $timeout, $location,$filter){ 
                            
  $scope.loading = true;
  $scope.step = "zero";
  $scope.error = '';
  $scope.emailpattern = /^[a-zA-Z0-9=*!$&_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  $scope.phoneregex = /^[0-9()+.-]{10,}$/;
  $scope.paymentMethod='';                         
  var url = $location.url();
  if (url!=='')
    $scope.step = url.substring(1,1000);
                           
  $http({method: 'GET', url: '/pages/catalogs-json'}).
    success(function(data, status, headers, config) {
      /* clean up trailing markup, may not be required in production */
      var result2;
      if (!Array.isArray(data)) {
        var result1 = data.replace(/<(?:.|\n)*?>/gm, '').replace(/{}\s*$/,'');
        result2 = JSON.parse(result1);
      } else
        result2 = data;
      var result3 = [];
    
    $scope.allCollections = result2;
/*
      Here is where the collections dropdown is filtered
*/    
      angular.forEach(result2, function(value) {
        //if (!(/in-?stock$|(games$)|(accessories$)|(hardware$)|(imports{0,1})$/i).test(value.handle)
        //                && !(/in( |-)?stock$/i).test(value.name) )
        if(jQuery.inArray(value.name, whitelist) != -1)
          this.push(value);
      },result3);
      $scope.collections = result3;
      $scope.error = '';
    }).
    error(function(data, status, headers, config) {
      $scope.error = 'Error communicating with server';
    });
  
   
  //hide search result div in the beginning 
  
                             
  $scope.search = function(){
    var model = {};
    $scope.collections = [
                          {handle:'A26', name:'Atari 2600'},
                          {handle:'sg', name:'Sega Genesis'}]; 
    $scope.accessories = [
                          {handle:'GAMES', name:'Games'},
                          {handle:'OTHER', name:'Accessory'},
                          {handle:'HW', name:'Hardware'},
                          {handle:'ALL', name:'All'}];
    $scope.searchresults = [];
    $scope.emptyresults = true;
    model.emptycart = true;
    $scope.title = ''; 
    
   
    
    try {
      var ls = localStorage.getItem( 'GOVGcart' );   
      model.tradecart = JSON.parse(ls);
      
    } catch(e) {
      model.tradecart = [];
    } 
    
    $scope.submitSearch = function(){
      
      $scope.search_complete=false; 
      
      if ($scope.form1.$valid) {
         $scope.yesHideResults=false; 
        var collection = $scope.collection.handle;
        var accessory = $scope.accessory.handle;
        console.log('accessory:', accessory);
        console.log('collection', collection);
        
        $http({method: 'GET', url: '/collections/' + collection + '?view=json'}).
          success(function(data, status, headers, config) {
          /* at some point we were getting an HTML string it may reverse*/
             $scope.search_complete=true;
            var result2
            if (typeof data === 'string') {
              var result1 = data.replace(/<(?:.|\n)*?>/gm, '').replace(/{}\s*$/,'');
              result2 = JSON.parse(result1);
            } else
              result2 = data;
            $scope.searchresults = [];
          
            angular.forEach(result2, function(value) {
              if (typeof value.title !== 'string')
                return null;
              var nameMatch = value.title.toUpperCase().indexOf($scope.title.toUpperCase()) !== -1;
              if (accessory === 'ALL' && nameMatch){
                  this.push(value); 
              } else if (accessory === 'HW' && endsWith(value.type.toUpperCase(), ':HW') ) {
                   this.push(value);   
              } else if (accessory === 'GAMES' && endsWith(value.type.toUpperCase(), ':USED') && nameMatch ) {
                this.push(value);
              } else if (accessory === 'OTHER' && endsWith(value.type.toUpperCase(), ':ACC') && nameMatch ) { //Accessories
                this.push(value);
              }  
            }, $scope.searchresults); 
            
            $scope.emptyresults = $scope.searchresults.length === 0;
      		$scope.error = '';
           
            
          }).
          error(function(data, status, headers, config) {
            $scope.search_complete=true;
      		$scope.error = 'Error communicating with server';
          });
      } 
      else if(!$scope.form1.$valid){
        $scope.search_complete=true;
        $scope.yesHideResults=true;
      } 
      $scope.search_attempted = true;
      
      
       
    }
    
    
    model.cartempty = function () {
      return model.tradecart == 0;
    }
    
   
    
    
    $scope.submit1 = function () {
      if (model.tradecart.length>0) {
        $scope.step='two';
        $scope.form1_attempted = false;
      }
      $scope.form1_attempted = true;
    }  
    
    $scope.add = function(product) {
       var found = 0;
       var trade = [];
       angular.forEach(model.tradecart , function(value) {
          if (value.handle === product.handle){
             value.qty = value.qty + 1
             found = 1;
          }
          this.push(value);
       }, trade);
       if (found === 0)
         trade.push(angular.extend({qty:1}, product));
       model.tradecart = trade;
    };

    $scope.addQty = function (item, qty) {
       var maxQty = 5;
       if( item.qty + qty <= maxQty)
         item.qty = item.qty + qty;
       var trade = [];
       angular.forEach(model.tradecart , function(value) {
          if (value.qty !== 0)
             this.push(value);
       }, trade);
       model.tradecart = trade;
    } 
    
   
 
    $scope.$watch('search.tradecart', function(newValue, oldValue) {
      localStorage.setItem( 'GOVGcart', JSON.stringify(newValue) ); 
    }, true); 
    
   
    
    
    return model; 
  }(); // end of search function 

  $scope.contact = function(){
    //console.log('contact');
	var model = {};
    model.discountedTotal = function () {
      var total = 0;
      angular.forEach($scope.search.tradecart, function(item) {
      	discounted = $scope.discounted(item);
      	total = total + discounted;
      });
      
      return total;
    }

    
    model.firstname='';
    model.lastname='';
    model.address1='';
    model.address2='';
    model.city='';
    model.state='';
    model.zip='';
    model.phone='';
    model.email='';
    $scope.submit2 = function () {
      $scope.form2_attempted = true;
      if ($scope.form2.$valid)
        $scope.step='three';
    };
    $scope.statelist = [{"name":"Alabama","handle":"AL"},{"name":"Alaska","handle":"AK"},{"name":"American Samoa","handle":"AS"},{"name":"Arizona","handle":"AZ"},{"name":"Arkansas","handle":"AR"},{"name":"California","handle":"CA"},{"name":"Colorado","handle":"CO"},{"name":"Connecticut","handle":"CT"},{"name":"Delaware","handle":"DE"},{"name":"District Of Columbia","handle":"DC"},{"name":"Federated States Of Micronesia","handle":"FM"},{"name":"Florida","handle":"FL"},{"name":"Georgia","handle":"GA"},{"name":"Guam","handle":"GU"},{"name":"Hawaii","handle":"HI"},{"name":"Idaho","handle":"ID"},{"name":"Illinois","handle":"IL"},{"name":"Indiana","handle":"IN"},{"name":"Iowa","handle":"IA"},{"name":"Kansas","handle":"KS"},{"name":"Kentucky","handle":"KY"},{"name":"Louisiana","handle":"LA"},{"name":"Maine","handle":"ME"},{"name":"Marshall Islands","handle":"MH"},{"name":"Maryland","handle":"MD"},{"name":"Massachusetts","handle":"MA"},{"name":"Michigan","handle":"MI"},{"name":"Minnesota","handle":"MN"},{"name":"Mississippi","handle":"MS"},{"name":"Missouri","handle":"MO"},{"name":"Montana","handle":"MT"},{"name":"Nebraska","handle":"NE"},{"name":"Nevada","handle":"NV"},{"name":"New Hampshire","handle":"NH"},{"name":"New Jersey","handle":"NJ"},{"name":"New Mexico","handle":"NM"},{"name":"New York","handle":"NY"},{"name":"North Carolina","handle":"NC"},{"name":"North Dakota","handle":"ND"},{"name":"Northern Mariana Islands","handle":"MP"},{"name":"Ohio","handle":"OH"},{"name":"Oklahoma","handle":"OK"},{"name":"Oregon","handle":"OR"},{"name":"Palau","handle":"PW"},{"name":"Pennsylvania","handle":"PA"},{"name":"Puerto Rico","handle":"PR"},{"name":"Rhode Island","handle":"RI"},{"name":"South Carolina","handle":"SC"},{"name":"South Dakota","handle":"SD"},{"name":"Tennessee","handle":"TN"},{"name":"Texas","handle":"TX"},{"name":"Utah","handle":"UT"},{"name":"Vermont","handle":"VT"},{"name":"Virgin Islands","handle":"VI"},{"name":"Virginia","handle":"VA"},{"name":"Washington","handle":"WA"},{"name":"West Virginia","handle":"WV"},{"name":"Wisconsin","handle":"WI"},{"name":"Wyoming","handle":"WY"}];
    $scope.stateupdate = function () {
      model.state = $scope.state.name;
    };
    return model;
  }();

  $scope.confirmation = function() {
    var model = {};
    
    try {
      var ls = localStorage.getItem( 'GOVGpaymentType' );
      if (ls.length > 0)
        $scope.paymentType = ls;
      else
    	$scope.paymentType = 'store_credit'; //default value is not set on $scope.obj.att
      
    } catch(e) {
      $scope.paymentType = 'store_credit'; //default value is not set on $scope.obj.att
    }
    
    
    model.validThrougth = function () {
      var __otherDate = new Date();
      __otherDate.setDate(__otherDate.getDate() + 30); 
      return (__otherDate.getMonth() + 1) + '/' + __otherDate.getDate() + '/' + __otherDate.getFullYear();
    }
    model.payable='';
    model.email='';

  
  
  
    
    model.charity='American Cancer Society';    
    model.comments='';
    model.terms=false;
    model.paypalemailvalid = false;  /* conditional validation would not retrigger work on angular 1.2.32 */
    model.validateEmail = function(paymentType, email) {
		if( paymentType !== 'paypal' ) {
            return true;
        }
        return $scope.emailpattern.test(email);
    }
    
    $scope.$watch('paymentType', function (newValue, oldValue) {
      	model.paypalemailvalid = model.validateEmail(newValue,$scope.confirmation.email);
    });
    $scope.$watch('confirmation.email', function (newValue, oldValue) {
      	model.paypalemailvalid = model.validateEmail($scope.paymentType,newValue);
    });
    
    $scope.submit3 = function () { 
    
      $scope.form3_attempted = true;
      if ($scope.form3.$valid && model.paypalemailvalid) {
        
        $scope.finalsubmit();     
        
      } 
      
      else if ($scope.paymentType=='cash' || $scope.paymentType=='credit'){
         $scope.finalsubmit();    
      }
        
    };
    return model;
  }();
  $scope.discounted = function(item) {
    console.log('item:', item);
    var discounted = 0;
    if (item.price < 10) 
      discounted = item.price * item.qty * 0.3;
    else if (item.price <= 20) 
      discounted = item.price * item.qty * 0.35;
    else if (item.price <= 60) 
      discounted = item.price * item.qty * 0.4;
    else if (item.price <= 100) 
      discounted = item.price * item.qty * 0.45;
    else
      discounted = item.price * item.qty * 0.5;
    //console.log('discounted', discounted);
    
    var result = 0;
    if ($scope.paymentType === "store_credit" || $scope.paymentType === "charity")
    	result = Math.round(discounted * 100) / 100;
    else
    	result = Math.round(discounted * 0.50 * 100) / 100;
    //console.log('result', result);
    return result;
  }
                             
  $scope.finalsubmit = function () {
    console.log('finalsubmit');
    var total = 0;
    var discounted;
    var lineitems = '';
    var formattedItems='';
    var discountedFormatted;
    var totalFormatted; 
    /*angular.forEach($scope.search.tradecart, function(item) {
      
      discounted = $scope.discounted(item);
      total = total + discounted;
      lineitems = lineitems + 'Total trade-in value:' + discounted + ' qty:' + item.qty + ' id:' + item.id + ' ' + item.title       
      + '-------------------------------------------------------------------------------------------------------------------\r\n';
    });*/
    
    var formOfPayment = $scope.paymentType 
    switch (formOfPayment) {
      case "check":
        formOfPayment = formOfPayment + ' ' + $scope.confirmation.payable
        break;
      case "paypal":
        formOfPayment = formOfPayment + ' ' + $scope.confirmation.email
        break;
      case "charity":
        formOfPayment = formOfPayment + ' ' + $scope.confirmation.charity
        break; 
        
    }
    
    
    /*We need to save final form since we are about to redirect and lose state*/
    localStorage.setItem("GOVGtradeform",document.getElementById('printableItems').innerHTML);
    localStorage.setItem("GOVGpaymentType",$scope.paymentType);
    /*formatted items */
     angular.forEach($scope.search.tradecart, function(item) {
       discounted = $scope.discounted(item);
       total = total + discounted;
       discountedFormatted=$filter('currency')(discounted); 
       formattedItems= formattedItems + ' Title: ' + item.title + '\n Qty: ' + item.qty + 
        '\n id: ' + item.id + '\nValue: '+ discountedFormatted +'\n\n';
    });
   
    totalFormatted= $filter('currency')(total); 
    
    $timeout(function() {
      angular.element("[name='q5_name[first]']").val($scope.contact.firstname);
      angular.element("[name='q5_name[last]']").val($scope.contact.lastname);
      angular.element("[name='q3_address[addr_line1]']").val($scope.contact.address1);
      angular.element("[name='q3_address[addr_line2]']").val($scope.contact.address2);
      angular.element("[name='q3_address[city]']").val($scope.contact.city);
      angular.element("[name='q3_address[state]']").val($scope.contact.state);
      angular.element("[name='q3_address[postal]']").val($scope.contact.zip);
      angular.element("[name='q3_address[country]']").val('US');
      angular.element("[name='q4_email4']").val($scope.contact.email);
      //angular.element("[name='q6_lineItems']").val(lineitems);
      angular.element("[name='q7_total']").val(totalFormatted);
      angular.element("[name='q8_formOf']").val(formOfPayment);           
      angular.element("[name='q9_comments']").val($scope.confirmation.comments);
    
      angular.element("#input_10").val(formattedItems);
      angular.element('.form-submit-button').trigger('click');
    }, 100);
  } 
  
  // empty the cart after the final step has rendered 
  if($scope.step == 'four'){    
     $timeout(function(){
       localStorage.setItem("GOVGcart","");
     }, 0); 
    
    $scope.paymentMethod = localStorage.getItem("GOVGpaymentType"); 
    
  }                         
  
  $scope.printDiv = function(divName) {
    var printContents = '';

    if ($scope.step == 'four') 
      /* Thank you comes from a redirect, state is lost */
      printContents = localStorage.getItem("GOVGtradeform");
    else
      printContents = document.getElementById(divName).innerHTML;
    
    var popupWin = window.open('', '_blank', 'width=300,height=300');
    popupWin.document.open();
    popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="//gameovervideogames.com/cdn/shop/t/35/assets/style.tradein.print.scss?v=34734841495996041791753802075" /></head><body onload="window.print()" style="font-size:8pt;">' + printContents + '</body></html>');
    popupWin.document.close();
  }  
 

                             
  /*$scope.registerCustomer= function(){
    
 
    
    
        var regFirstName=$scope.regFirstName; 
        var regLastName=$scope.regLastName; 
        var regEmail=$scope.regEmail; 
        var regPassword=$scope.regPassword; 
        $scope.registrationError='';
    
    var data ='form_type=create_customer&utf8=%E2%9C%93&customer%5Bfirst_name%5D='+regFirstName+'&customer%5Blast_name%5D='+regLastName+'&customer%5Bemail%5D='+regEmail+'&customer%5Bpassword%5D='+regPassword;
    
  
    $http({
      method:'POST', 
      url:'/account', 
      data: data, 
      headers: {'Content-Type': 'application/x-www-form-urlencoded'} 
     })
     .success(function(html, status, headers, config){
      
         	if (html.indexOf('email is invalid') !== -1) {
               $scope.registrationError='Email is invalid';
            } else if (html.indexOf('email can&#39;t be blank') !== -1) {
              $scope.registrationError='An email must be filled out'; 
            } else if (html.indexOf('password can&#39;t be blank.') !== -1) {
              $scope.registrationError='A password must be filled out'; 
            }
            else if (html.indexOf('This email address is already associated with an account') !==-1){
               $scope.registrationError='This email is already taken.'; 
               }
            else if (html.indexOf('Password is too short') !== -1) {
              $scope.registrationError='The Password must be a minimum of 5 characters'; 
            }
            else{
              window.location='/pages/tradein?showTerms=yes'    
            }
      
       console.log(headers("Location"));
            
      
         
      }) 
     .error(function(error, status){
        console.log('There was an issue'); 
     })
    
 
   }*/ // end function
     

  
$scope.modalLogin = function($event) {
    if ($event) $event.preventDefault(); // Stop native form submission

    var loginPassword = $scope.loginPassword; 
    var loginEmail = $scope.loginEmail; 

    $scope.loginError = '';

    // Validation
    if (!loginEmail || !loginPassword) {
        $scope.loginError = "Please enter both email and password.";
        return;
    }

    var data = 'form_type=customer_login&utf8=%E2%9C%93&customer%5Bemail%5D=' 
               + encodeURIComponent(loginEmail) 
               + '&customer%5Bpassword%5D=' 
               + encodeURIComponent(loginPassword);

    $http({
        method: 'POST', 
        url: '/account/login', 
        data: data, 
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
    .success(function(html) {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    var errorElement = tempDiv.querySelector('.errors');

    if (errorElement) {
        $scope.loginError = errorElement.textContent || "Invalid login.";
    } else {
        window.location = '/pages/tradein?showTerms=yes';
    }
})

    .error(function(error, status) {
        console.log('There was an issue with the login');
    });
};

  
 $scope.hideResults=function(){
   $scope.yesHideResults=true;
 }
 


}]);
  
})();

